import { render, staticRenderFns } from "./Death.vue?vue&type=template&id=8833e5f4&scoped=true&"
import script from "./Death.vue?vue&type=script&lang=js&"
export * from "./Death.vue?vue&type=script&lang=js&"
import style0 from "./Death.vue?vue&type=style&index=0&id=8833e5f4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8833e5f4",
  null
  
)

export default component.exports